<!-- @format -->

<h5 class="fudis-heading__md">{{ "PROFILE.STUDY_RIGHT_STATE_TITLE" | translate }}</h5>
@if (!!activeStatePeriod) {
  <div>{{ "PROFILE.STATE." + activeStatePeriod.state | translate }}</div>
}

@if (isCancelled() || isPassivated()) {
  <div class="sis-pb-sm">
    <sis-button
      class="show-decision-details-button"
      [dataCy]="'show-decision-details-button'"
      [link]="true"
      (clicked)="showDecisionDetails()">
      {{ "PROFILE.EXTENSIONS.SHOW_DETAILS" | translate }}
    </sis-button>
  </div>
}

<sis-expandable [level]="6" [variant]="'link'" [title]="'PROFILE.SHOW_ALL_STUDY_RIGHT_STATES' | translate" data-cy="show-all-states-button">
  <ng-template sisExpandableContent>
    <table
      class="sis-table styled-table"
      role="table"
      data-cy="study-right-states-table"
      [attr.aria-label]="'PROFILE.STUDY_RIGHT_STATES_PREVIOUS' | translate">
      <thead>
        <tr>
          <th>{{ "PROFILE.STARTS" | translate }}</th>
          <th>{{ "PROFILE.EXPIRES" | translate }}</th>
          <th>{{ "PROFILE.STATE" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (period of statePeriods; track period) {
          <tr class="form-control-static" [class.past-study-rights]="period | dateRangePast">
            <td [class.text-center]="!period.startDate">
              @if (period === activeStatePeriod) {
                <strong>
                  <ng-container *ngTemplateOutlet="startDate" />
                </strong>
              } @else {
                {{ (period?.startDate | localDateFormat) || "-" }}
              }
            </td>
            <td [class.text-center]="!period.endDate">
              @if (period === activeStatePeriod) {
                <strong>
                  <ng-container *ngTemplateOutlet="endDate" />
                </strong>
              } @else {
                {{ (getInclusiveEndDate(period) | localDateFormat) || "-" }}
              }
            </td>
            <td>
              @if (period === activeStatePeriod) {
                <strong>
                  <ng-container *ngTemplateOutlet="state" />
                </strong>
              } @else {
                {{ "PROFILE.STATE." + period.state | translate }}
              }
            </td>
            <ng-template #startDate>{{ (period?.startDate | localDateFormat) || "-" }}</ng-template>
            <ng-template #endDate>{{ (getInclusiveEndDate(period) | localDateFormat) || "-" }}</ng-template>
            <ng-template #state>{{ "PROFILE.STATE." + period.state | translate }}</ng-template>
          </tr>
        }
      </tbody>
    </table>
  </ng-template>
</sis-expandable>
